// Central site content & configuration for Fly Gowell Travel Solutions.
// Swap FORMSPREE_ENDPOINT with the real form ID once available.

export const FORMSPREE_ENDPOINT = "https://formspree.io/f/xeeyywwd";

export const CONTACT = {
  address: "48 Ground Floor, Bharat Nagar, New Friends Colony, New Delhi – 110025",
  phones: ["9911225119", "9911225116", "9911225120"],
  landline: "+91-11-41601966",
  emails: ["Info@flygowell.com", "flygowell7@gmail.com"],
  website: "www.flygowell.com",
  whatsappNumber: "919911225119",
};

export const WHATSAPP_LINK = (msg) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const DEFAULT_WA_MESSAGE =
  "Hi Fly Gowell, I'd like to enquire about your corporate travel services.";

// Google Maps — office plus code pin
export const MAPS_QUERY = encodeURIComponent("H78C+HC New Delhi, Delhi");
export const MAPS_EMBED = `https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`;
export const MAPS_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${MAPS_QUERY}`;

// Downloadable corporate brochure (served from /public)
export const BROCHURE_URL = "/FlyGowell-Corporate-Travel-Brochure.pdf";

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Corporate Services", path: "/corporate-services" },
  { label: "Visa Services", path: "/visa-services" },
  { label: "Vision & Mission", path: "/vision-mission" },
  { label: "Why Fly Gowell", path: "/why-fly-gowell" },
  { label: "Contact Us", path: "/contact" },
];

export const CORE_SERVICES = [
  {
    icon: "Ticket",
    title: "Ticketing",
    desc: "Seamless domestic, international, and SOTO flight bookings optimized for corporate and business travel.",
  },
  {
    icon: "Stamp",
    title: "Visa Assistance",
    desc: "Complete visa support for business, conference, tourism, family visits and transit, with ETA, PAR and documentation. Covers subcategories like Sports, Academic Visits, Events and Medical Emergencies.",
  },
  {
    icon: "ShieldCheck",
    title: "Travel Insurance",
    desc: "Tailored insurance plans for business, tourism, and Schengen-compliant travel.",
  },
  {
    icon: "FileCheck2",
    title: "Documentation Support",
    desc: "End-to-end review and management of travel documents for hassle-free travel.",
  },
  {
    icon: "Briefcase",
    title: "Executive Travel Management",
    desc: "Customized itineraries, urgent rerouting, multi-destination planning, and corporate credit facilities (10–15 days).",
  },
  {
    icon: "Globe2",
    title: "Tourism Travel Services",
    desc: "Professional arrangements for corporate tourism, family visits, leisure, and holiday packages.",
  },
];

export const STATS = [
  { value: "20", label: "Years of Trust" },
  { value: "1000+", label: "Clients Served" },
  { value: "Trusted", label: "Across Industries" },
  { value: "High", label: "Visa Approval Rate" },
];

export const DESTINATIONS = [
  { name: "London", img: "https://images.pexels.com/photos/14434677/pexels-photo-14434677.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "Dubai", img: "https://images.pexels.com/photos/19741511/pexels-photo-19741511.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "Singapore", img: "https://images.pexels.com/photos/5097071/pexels-photo-5097071.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "New York", img: "https://images.unsplash.com/photo-1570304816841-906a17d7b067?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxOZXclMjBZb3JrJTIwY2l0eXNjYXBlJTIwc2t5bGluZXxlbnwwfHx8fDE3ODQ1ODE3MDN8MA&ixlib=rb-4.1.0&q=85" },
  { name: "Paris", img: "https://images.pexels.com/photos/1694498/pexels-photo-1694498.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "Tokyo", img: "https://images.pexels.com/photos/31048512/pexels-photo-31048512.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "Sydney", img: "https://images.pexels.com/photos/57389/milsons-point-sydney-australia-sydney-opera-house-57389.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "Hong Kong", img: "https://images.pexels.com/photos/31713313/pexels-photo-31713313.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "Toronto", img: "https://images.pexels.com/photos/25696388/pexels-photo-25696388.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "Frankfurt", img: "https://images.pexels.com/photos/19433777/pexels-photo-19433777.jpeg?auto=compress&cs=tinysrgb&w=1000" },
];

export const HERO_IMG = "/hero-airport.png";

export const DIRECTOR_IMG = "/abul-photo.jpg";

export const WORLD_VISAS = [
  { name: "USA", code: "us" },
  { name: "United Kingdom", code: "gb" },
  { name: "Canada", code: "ca" },
  { name: "Australia", code: "au" },
  { name: "UAE", code: "ae" },
  { name: "Singapore", code: "sg" },
  { name: "Japan", code: "jp" },
  { name: "China", code: "cn" },
];

export const SCHENGEN_VISAS = [
  { name: "France", code: "fr" },
  { name: "Germany", code: "de" },
  { name: "Italy", code: "it" },
  { name: "Spain", code: "es" },
  { name: "Netherlands", code: "nl" },
  { name: "Switzerland", code: "ch" },
  { name: "Austria", code: "at" },
  { name: "Belgium", code: "be" },
  { name: "Greece", code: "gr" },
  { name: "Portugal", code: "pt" },
];
